import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IThongTinCbnvActionTypes } from "../../action-types/thongtin-cbnv/IThongTinCbnvActionTypes";
import { IThongTinCbnvReducer } from "../../page-state-model/thongtin-cbnv/IThongTinCbnvReducer";
const iniState: IThongTinCbnvReducer = {
    status: ePageBaseStatus.is_not_initialization,
    thongTinCbnvs: []
}
export const thongTinCbnvReducer = (state: IThongTinCbnvReducer = iniState, action: IThongTinCbnvActionTypes): IThongTinCbnvReducer => {
    switch (action.type) {
        case "THONG_TIN_CBNV_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "THONG_TIN_CBNV_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                thongTinCbnvs: action.payload
            }
        case "THONG_TIN_CBNV_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                thongTinCbnvs: []
            }
        case "THONG_TIN_CBNV_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "THONG_TIN_CBNV_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "THONG_TIN_CBNV_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "THONG_TIN_CBNV_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "THONG_TIN_CBNV_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "THONG_TIN_CBNV_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "THONG_TIN_CBNV_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "THONG_TIN_CBNV_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}